/**
 * Embed a Ask Us Chat block in a page.
 * Used as part of the AskChatTab component.
 */
import React from 'react';

import WebForm from 'src/uglib_components/webform';
import * as styles from 'src/uglib_styles/contactForm.module.css'

import { name } from 'src/uglib_utils/forms';

function ContactForm (props) {

    return (<>
        <div className={styles.contact_form_wrapper}> 
            <WebForm name="library-contact">
                {name}

                <div> 
                    <fieldset className="compound">
                        <legend>You are...</legend>
                        <div id="submitted-you-are" className={styles.radios}>
                            <label for="submitted-you-are-1">
                                <input type="radio" id="submitted-you-are-1" name="status[you_are]" value="undergrad" />
                                <span>an undergraduate student</span>
                            </label>
                            <label for="submitted-you-are-2">
                                <input type="radio" id="submitted-you-are-2" name="status[you_are]" value="grad" />
                                <span>a graduate student</span>
                            </label>
                            <label for="submitted-you-are-3">
                                <input type="radio" id="submitted-you-are-3" name="status[you_are]" value="faculty" />
                                <span>a faculty member</span></label>
                            <label for="submitted-you-are-4">
                                <input type="radio" id="submitted-you-are-4" name="status[you_are]" value="staff" />
                                <span>university staff</span>
                            </label>
                            <label for="submitted-you-are-5">
                                <input type="radio" id="submitted-you-are-5" name="status[you_are]" value="alumni" />
                                <span>an alumnus/alumna</span>
                            </label>
                            <label for="submitted-you-are-6">
                                <input type="radio" id="submitted-you-are-6" name="status[you_are]" value="community" />
                                <span>a Guelph community member</span>
                            </label>
                            <label for="submitted-you-are-7">
                                <input type="radio" id="submitted-you-are-7" name="status[you_are]" value="other" />
                                <span>other</span>
                            </label>
                        </div>
                    </fieldset>
                
                </div>
                
                {/* Don't update this field_name without also updating the webform handler app */}
                <label for="email">
                    <span>Leave your email address if you want a response</span>
                    <input type="email" name="email" id="email" autocomplete="email" />
                </label>

                <label for="message">
                    <span>How can we help you?</span>
                    <textarea name="message" id="message" rows="5" required />
                </label>

                <a href="https://www.lib.uoguelph.ca/about/policies/personal-information-policy">Comments and questions will be kept confidential</a>
            </WebForm>
        </div>
    </>);
    
}
  
export default ContactForm